import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RunIdSchema } from "../primitives/ids.js";
import { EnreinArtifactUriSchema } from "./artifact-uri.js";
export const ArtifactSetV1Schema = z
    .object({
    schemaVersion: z.literal("artifact-set.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    runId: RunIdSchema,
    artifactSetHash: z.string().min(1),
    artifacts: z.array(z
        .object({
        uri: EnreinArtifactUriSchema,
        name: z.string().min(1),
        clientSafe: z.boolean(),
    })
        .strict()),
})
    .strict();
//# sourceMappingURL=artifact-set.js.map